import { computed } from 'vue'
import { useRoute } from 'vue-router'

export function useRoutePage() {
  const route = useRoute()

  const isDashboardPage = computed(() => route.name?.startsWith('dashboard'))
  const isSettingsPage = computed(() => route.name?.startsWith('settings'))

  const isDashboardOrSettingsPage = computed(() => isDashboardPage.value || isSettingsPage.value)

  return {
    isDashboardPage,
    isSettingsPage,
    isDashboardOrSettingsPage,
  }
}
